"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgFlightDirectAdditionalMobile = function SvgFlightDirectAdditionalMobile(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 97 19",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#B5A48B",
    d: "M9 19.3S21.601 16 48.995 16c27.393 0 39.994 3.3 39.994 3.3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.5,
    cy: 19.5,
    r: 1.5,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#877C68",
    d: "M20 13.954c6.186-2.067 18.55-4.696 30.118-4.696 25.966 0 37.91 9.393 37.91 9.393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.725 9.05-2.683-.957s-.794-.188-1.366-1.291a212.204 212.204 0 0 1-1.146-2.247s-.093-.268-.394-.262c-.3.006-.22.331-.22.331l.132 2.31s-.054.56.397.953c.452.393 1.815 1.52 1.815 1.52s.94.763 2.505 1.308c1.564.545 7.09 2.547 7.09 2.547s2.092.826 2.328.382c.236-.444-.57-1.244-1.042-1.556-.472-.313-4.968-2.095-4.968-2.095l-1.685-4.58s-.266-.553-.347-.103c-.081.45-.488 4.546-.488 4.546m-.559 1.926-.176 1.757s.006.464.828-.107c.822-.571 1.45-.984 1.45-.984M8.286 16.835 5.67 17.963s-.708.405-1.88-.012c-1.17-.416-2.37-.861-2.37-.861s-.25-.133-.467.076c-.216.21.065.392.065.392l1.672 1.6s.342.446.94.426c.6-.02 2.365-.126 2.365-.126s1.208-.084 2.724-.752c1.515-.668 6.922-2.972 6.922-2.972s2.093-.823 1.963-1.309c-.13-.486-1.265-.52-1.823-.427-.559.092-5.062 1.855-5.062 1.855l-4.356-2.2s-.571-.223-.324.162c.248.384 2.743 3.657 2.743 3.657m.905 1.79 1.07 1.406s.32.335.532-.644c.212-.978.39-1.708.39-1.708",
    stroke: "#251C0E"
  })));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgFlightDirectAdditionalMobile);
var _default = Memo;
exports["default"] = _default;